query GetBalanceReconciliationTransactions(
  $legalEntity: ReconciliationLegalEntity!
  $fundCategories: [FundCategory!]
  $dateFrom: ISO8601Date
  $dateTo: ISO8601Date
) {
  balanceReconciliationTransactions(
    legalEntity: $legalEntity
    fundCategories: $fundCategories
    dateFrom: $dateFrom
    dateTo: $dateTo
  ) {
    sageLines {
      id
      giftAccountName
      giftAccountCode
      matched
      batchReference
      batchDate
      generalLedgerAccount
      generalLedgerName
      reportingAmount {
        minorUnit
        currency
      }
      memo
    }
    salesforceLines {
      id
      caseRecordId
      caseNumber
      matched
      subject
      recordType
      transactionDate
      side
      giftAccountName
      giftAccountCode
      amount {
        minorUnit
        currency
      }
    }
  }
}
